import React from 'react';
export function CostTable() {
  const rows = [{
    sin: 'Delivery 3 veces por semana',
    costo: '$780.000 – $1.560.000 ARS por año'
  }, {
    sin: 'Compras sin lista → desperdicio del 25%',
    costo: '$50.000 – $90.000 ARS perdidos por mes'
  }, {
    sin: '1 hora diaria de decisión sobre comida',
    costo: '365 horas de tu vida por año'
  }, {
    sin: 'Ingredientes vencidos en heladera',
    costo: '$15.000 – $30.000 ARS tirados por mes'
  }, {
    sin: 'El mismo ciclo sin sistema',
    costo: 'El próximo año. Igual que este.'
  }];
  return <section className="py-20 px-4" data-id="element-65">
      <div className="max-w-4xl mx-auto" data-id="element-66">
        <h2 className="text-3xl md:text-4xl font-bold mb-12 text-center flex items-center justify-center gap-3" data-id="element-67">
          <span data-id="element-68">⚖️</span> ¿CUÁNTO CUESTA NO TENERLO?
        </h2>

        <div className="bg-brand-card rounded-3xl border border-red-900/30 overflow-hidden" data-id="element-69">
          <div className="grid grid-cols-1 md:grid-cols-2 border-b border-white/10" data-id="element-70">
            <div className="p-4 md:p-6 text-lg font-bold text-gray-400 bg-black/20 hidden md:block" data-id="element-71">
              Sin el Pack
            </div>
            <div className="p-4 md:p-6 text-lg font-bold text-red-400 bg-red-950/20 hidden md:block" data-id="element-72">
              Costo real
            </div>
          </div>

          <div className="divide-y divide-white/5" data-id="element-73">
            {rows.map((row, i) => <div key={i} className="grid grid-cols-1 md:grid-cols-2" data-id="element-74">
                <div className="p-4 md:p-6 bg-black/20 md:border-r border-white/5 text-gray-300" data-id="element-75">
                  <span className="md:hidden font-bold text-gray-500 text-xs uppercase block mb-1" data-id="element-76">
                    Sin el Pack
                  </span>
                  {row.sin}
                </div>
                <div className="p-4 md:p-6 bg-red-950/10 text-red-300 font-medium" data-id="element-77">
                  <span className="md:hidden font-bold text-red-500/50 text-xs uppercase block mb-1" data-id="element-78">
                    Costo real
                  </span>
                  {row.costo}
                </div>
              </div>)}
          </div>
        </div>
      </div>
    </section>;
}